import { Link } from 'react-router-dom';
import { Page } from '@/components/Page';

export default function NotFound() {
  return (
    <Page title="Aquí no hay nada">
      <p className="text-[var(--color-text-muted)]">
        Esa página no existe.{' '}
        <Link to="/" className="font-medium text-[var(--color-brand-strong)] underline">
          Volver a Hoy
        </Link>
      </p>
    </Page>
  );
}
